export default "__VITE_ASSET__Dm7b2uFa__"